import { Control, CustomPattern, Email, MatchesControl, MinLength, Required } from "@recursyve/ngx-form-generator";
import { NiceBaseForm } from "@recursyve/nice-ui-kit.v2";
import { RegisterOwnersDto } from "../../../../api/nerri/owners/dto/register-owners.dto";

export class RegisterOwnerForm extends NiceBaseForm<RegisterOwnerForm, Omit<RegisterOwnersDto, "uuid">> {
    @Control()
    @Required()
    @Email()
    email: string;

    @Control()
    @Required()
    @MinLength(8)
    @CustomPattern(/[A-Z]/, { must_have_1_uppercase_letter: true })
    @CustomPattern(/[a-z]/, { must_have_1_lowercase_letter: true })
    @CustomPattern(/[0-9]/, { must_have_1_number: true })
    @CustomPattern(/[!@#$%^&*()\-+=_\[\]{};:'",.<>?\/\\|]/, { must_have_1_symbol: true })
    password: string;

    @Control()
    @Required()
    @MatchesControl("password")
    confirmPassword: string;

    public override toDto(): Omit<RegisterOwnersDto, "uuid"> {
        return {
            email: this.email,
            password: this.password
        };
    }
}
